
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class TwentyOneTable extends Vue {
    //21点
    table = {
        data: [],
        column: [
            {
                key: 'Bet',
                title: '投注金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        color: index == 1 ? 'red' : '#333'
                                    },
                                    domProps: {
                                        innerHTML: (this as any).getMoney(v.Bet)
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'Insure',
                title: '保险金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        color: index == 1 ? 'red' : '#333'
                                    },
                                    domProps: {
                                        innerHTML: (this as any).getMoney(v.Insure)
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'PVal',
                title: '点数',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        color: index == 1 ? 'red' : '#333'
                                    },
                                    domProps: {
                                        innerHTML: v.PVal
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'CT',
                title: '牌型',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        color: index == 1 ? 'red' : '#333'
                                    },
                                    domProps: {
                                        innerHTML: v.CT == 1 ? '单点' : v.CT == 50 ? '黑杰克' : '爆牌'
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'C',
                title: '玩家手牌',
                align: 'center',
                width: 230,
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        marginTop: '5PX'
                                    },
                                    domProps: {
                                        innerHTML: v.C.map((x) => {
                                            return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                        })
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'Pack',
                title: '是否分牌',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        color: index == 1 ? 'red' : '#333'
                                    },
                                    domProps: {
                                        innerHTML: v.Pack > 0 ? '是' : '否'
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'C',
                title: '庄家牌型',
                align: 'center',
                width: 230,
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo['0']
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        marginTop: '5PX'
                                    },
                                    domProps: {
                                        innerHTML: v.C.map((x) => {
                                            return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                            //  return   this.getPokerValue(x)
                                        })
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'Reason',
                title: '终止状态',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let arr = ['主动停牌', '超时停牌', '双倍停牌', '爆牌', '二十一点', '庄家黑杰克（立即结算）', '玩家黑杰克']
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    domProps: {
                                        innerHTML: arr[v.Reason]
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'RealAWard',
                title: '变动金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        color: index == 1 ? 'red' : '#333'
                                    },
                                    domProps: {
                                        innerHTML: (this as any).getMoney(v.RealAWard)
                                    }
                                })
                            })
                        )
                    }
                }
            },
            {
                key: 'PercentPoin',
                title: '税收金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let list = strzo[bulidUid(params.row.user_id, strzo)]
                    if (list) {
                        return h(
                            'div',
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        color: index == 1 ? 'red' : '#333'
                                    },
                                    domProps: {
                                        innerHTML: (this as any).getMoney(v.PercentPoin)
                                    }
                                })
                            })
                        )
                    }
                }
            }
        ]
    }

    @Prop()
    listdata
}
